import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Trash.svg?component
var Trash_exports = /* @__PURE__ */ __exportAll({
	default: () => Trash_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m19.5 5.75-1.51 14.34a1.67 1.67 0 0 1-1.66 1.5H7.67A1.67 1.67 0 0 1 6 20.08L4.5 5.75m-2.08 0h19.16m-13.33 0v-2.5a.83.83 0 0 1 .83-.83h5.84a.83.83 0 0 1 .83.83v2.5M12 9.5v8.75m3.75-8.75-.42 8.75M8.25 9.5l.42 8.75"
	}, null, -1)])]);
}
var Trash_default = { render: render$1 };
//#endregion
export { Trash_exports, Trash_default as default, render$1 as render };

//# sourceMappingURL=Trash.svg_component.js.map